import React, { PureComponent } from "react"
import iconFlag from "./icon/icon_flag.png"

export class FMatNameFlagRenderer extends PureComponent<any, any> {
  render() {
    const { name, showFlag, color } = this.props.value
    if (!name) return null
    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <span style={{ padding: "8px", background: color, marginRight: "5px" }} />
        {name}
        {showFlag ? <img src={iconFlag} style={{ marginLeft: "10px" }} /> : ""}
      </div>
    )
  }
}
